import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class EmailComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentEmail | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.clearOnHide = settings?.clearOnHide ?? true;
		this.defaultValue = settings?.defaultValue ?? '';
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.inputType = settings?.inputType ?? 'email';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.prefix = settings?.prefix ?? '';
		this.protected = settings?.protected ?? false;
		this.suffix = settings?.suffix ?? '';
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom,
			customMessage: settings?.validate?.customMessage,
			maxLength:     settings?.validate?.maxLength ?? null,
			minLength:     settings?.validate?.minLength ?? null,
			pattern:       settings?.validate?.pattern ?? '',
		};
	}
}
